import {useQuery} from 'react-query'
import {HawalaEditModalForm} from './HawalaEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getHawalaById} from '../core/_requests'

const HawalaEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {
    isLoading,
    data: hawala,
    error,
  } = useQuery(
    `${QUERIES.USERS_LIST}-hawala-${itemIdForUpdate}`,
    () => {
      return getHawalaById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )
  if (!itemIdForUpdate) {
    return <HawalaEditModalForm isHawalaLoading={isLoading} hawala={{id: undefined}} />
  }

  if (!isLoading && !error && hawala) {
    console.log({hawala, },"its hawala")
    console.log(typeof hawala,"its hawala")
    return <HawalaEditModalForm isHawalaLoading={isLoading} hawala={hawala} />
  }

  return null
}

export {HawalaEditModalFormWrapper}
